import { useNavigate } from "react-router-dom";

import { ROUTES } from "../../../../constants/routes";
import SavedIcon from "../../../../components/icons/searchIcons/savedIcon";
import styles from "./ActorCard.module.scss";

type Props = {
  actorId: number | undefined
  fullName: string
  description: string
  image: string
  isFav?: boolean
  onFavouriteClick?: (e: React.MouseEvent, actorId: number, isFav: boolean) => void
}

const ActorCard = ({ actorId, fullName, description, image, isFav = false, onFavouriteClick }: Props) => {
  const navigate = useNavigate();

  const clickHandler = () => {
    if (actorId) navigate(`${ROUTES.ACTORS}/${actorId}`);
  };

  return (
    <div className={styles.wrapper} onClick={clickHandler} style={actorId ? undefined : { cursor: "default" }}>
      <img
        width={130}
        height={130}
        className={styles.image}
        src={image ? image : ""}
        alt="#"
      />
      <div className={styles.textWrapper}>
        <div className={styles.nameRow}>
          <h3 className={styles.fullName}>{fullName}</h3>
          {actorId && onFavouriteClick && (
            <button
              className={styles.savedBtn}
              type="button"
              aria-label="toggle actor favorite"
              onClick={(e) => {
                e.stopPropagation();
                onFavouriteClick(e, actorId, isFav);
              }}
            >
              <SavedIcon className={styles.savedIcon} inFavourites={isFav} />
            </button>
          )}
        </div>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  )
}

export default ActorCard
